import Config from "Config";
import axiosCalls from "global/util/axiosCalls";
import EditHistoryDTO from "./dto/EditHistoryDTO";

const HistroryService = {
  loadByAutomatkey: (
    automatkey: string,
    callbackOnSuccess: Function,
    callbackOnFail?: Function
  ) => {
    axiosCalls
      .sendGet(`${Config.dataServiceUrl}historie/${automatkey}`)
      .then((response) => {
        callbackOnSuccess(EditHistoryDTO.convertEditHistoryResponse(response));
      })
      .catch((error) => {
        if (callbackOnFail) callbackOnFail(error);
      });
  },
};
export default HistroryService;
